import { createGlobalStyle } from "styled-components";

export const MyQuestionCss = createGlobalStyle`
    .myquestion-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: sans-serif;
        height: 100%;
        width: 100%;
        overflow-y: scroll;
    }
`;
